import L from 'leaflet';
import { findIndex } from 'lodash';
import noUiSlider from 'nouislider';

L.control.layerSlider = function (options, widget) {
	return new L.Control.LayerSlider(options, widget);
};

L.Control.LayerSlider = L.Control.extend({
	options: {
		position: 'topright',
		height: '50%',
		zIndex: 999,
		formatTo: function (value) {
			return this._layers[Math.floor(value)].options.title;
		},
	},

	initialize: function (options, widget) {
		L.Util.setOptions(this, options);

		this.widget = widget;
	},

	onAdd: function (map) {
		let container = L.DomUtil.create('div', 'widget-control-layerslider');
		L.DomEvent.disableScrollPropagation(container);
		L.DomEvent.disableClickPropagation(container);

		this._layers = this.widget.layers.getLayersByGroup(this.options.group);

		Object.assign(container.style, {
			height: this.options.height,
			zIndex: this.options.zIndex,
		});

		this._slider = noUiSlider.create(container, {
			start: [findIndex(this._layers, layer => layer._map)],
			direction: 'ltr',
			orientation: 'vertical',
			tooltips: true,
			step: 1,
			range: {
				min: 0,
				max: this._layers.length - 1,
			},
			format: {
				to: this.options.formatTo.bind(this),
				from: value => value,
			},
		});

		this._slider.on('change', (values, handle, unencoded, tap, positions) => {
			let index = Math.floor(unencoded[0]);
			let layer = this._layers[index];

			this.widget.layers.showLayer(layer.options.name);
		});

		this.widget.layers.on('LAYERS_LAYER_SHOWN LAYERS_LAYER_HIDDEN', this._update, this);

		return container;
	},

	onRemove: function (map) {
		this.widget.layers.off('LAYERS_LAYER_SHOWN LAYERS_LAYER_HIDDEN', this._update, this);

		this._slider.off();
		this._slider.destroy();
	},

	_update: function () {
		if (!this._map) {
			return;
		}

		var index = findIndex(this._layers, layer => layer._map);

		this._slider.set(index);
	},
})
